const telRegExp = /^\(\d{2}\) \d{4,5}-\d{4}$/;

export const validTel = (data) => telRegExp.test(data);
